module.exports = __webpack_public_path__ + "static/media/loon-image-original.4a00df53.jpg";